import type { NotificationOptionsState } from './NotificationOptionSchema';
import { createStore } from 'owa-satcheljs';

const defaultExport: () => NotificationOptionsState = createStore<NotificationOptionsState>(
    'notificationOptions',
    {}
);
export default defaultExport;
